import { LineSectionBaseInterface } from '../lines/types';
import { StopInterface as StopBaseInterface } from '../stops/types';

/*
 * Action Types
 */
export enum FareTaxTypes {
  LIST_FARE_TAX_REQUEST = '@fareTax/LIST_FARE_TAX_REQUEST',
  LIST_FARE_TAX_SUCCESS = '@fareTax/LIST_FARE_TAX_SUCCESS',
  LIST_FARE_TAX_FAILURE = '@fareTax/LIST_FARE_TAX_FAILURE',

  LIST_FARE_TAX_INTEGRATOR_REQUEST = '@fareTax/LIST_FARE_TAX_INTEGRATOR_REQUEST',
  LIST_FARE_TAX_INTEGRATOR_SUCCESS = '@fareTax/LIST_FARE_TAX_INTEGRATOR_SUCCESS',
  LIST_FARE_TAX_INTEGRATOR_FAILURE = '@fareTax/LIST_FARE_TAX_INTEGRATOR_FAILURE',

  GET_FARE_TAX_REQUEST = '@fareTax/GET_FARE_TAX_REQUEST',
  GET_FARE_TAX_SUCCESS = '@fareTax/GET_FARE_TAX_SUCCESS',
  GET_FARE_TAX_FAILURE = '@fareTax/GET_FARE_TAX_FAILURE',

  GET_FARE_TAX_INTEGRATOR_REQUEST = '@fareTax/GET_FARE_TAX_INTEGRATOR_REQUEST',
  GET_FARE_TAX_INTEGRATOR_SUCCESS = '@fareTax/GET_FARE_TAX_INTEGRATOR_SUCCESS',
  GET_FARE_TAX_INTEGRATOR_FAILURE = '@fareTax/GET_FARE_TAX_INTEGRATOR_FAILURE',

  FILTER_FARE_TAX_REQUEST = '@fareTax/FILTER_FARE_TAX_REQUEST',
  FILTER_FARE_TAX_SUCCESS = '@fareTax/FILTER_FARE_TAX_SUCCESS',
  FILTER_FARE_TAX_FAILURE = '@fareTax/FILTER_FARE_TAX_FAILURE',

  CREATE_FARE_TAX_REQUEST = '@fareTax/CREATE_FARE_TAX_REQUEST',
  CREATE_FARE_TAX_SUCCESS = '@fareTax/CREATE_FARE_TAX_SUCCESS',
  CREATE_FARE_TAX_FAILURE = '@fareTax/CREATE_FARE_TAX_FAILURE',

  CREATE_FARE_TAX_INTEGRATOR_REQUEST = '@fareTax/CREATE_FARE_TAX_INTEGRATOR_REQUEST',
  CREATE_FARE_TAX_INTEGRATOR_SUCCESS = '@fareTax/CREATE_FARE_TAX_INTEGRATOR_SUCCESS',
  CREATE_FARE_TAX_INTEGRATOR_FAILURE = '@fareTax/CREATE_FARE_TAX_INTEGRATOR_FAILURE',

  UPDATE_FARE_TAX_REQUEST = '@fareTax/UPDATE_FARE_TAX_REQUEST',
  UPDATE_FARE_TAX_SUCCESS = '@fareTax/UPDATE_FARE_TAX_SUCCESS',
  UPDATE_FARE_TAX_FAILURE = '@fareTax/UPDATE_FARE_TAX_FAILURE',

  UPDATE_FARE_TAX_INTEGRATOR_REQUEST = '@fareTax/UPDATE_FARE_TAX_INTEGRATOR_REQUEST',
  UPDATE_FARE_TAX_INTEGRATOR_SUCCESS = '@fareTax/UPDATE_FARE_TAX_INTEGRATOR_SUCCESS',
  UPDATE_FARE_TAX_INTEGRATOR_FAILURE = '@fareTax/UPDATE_FARE_TAX_INTEGRATOR_FAILURE',

  DELETE_FARE_TAX_REQUEST = '@fareTax/DELETE_FARE_TAX_REQUEST',
  DELETE_FARE_TAX_SUCCESS = '@fareTax/DELETE_FARE_TAX_SUCCESS',
  DELETE_FARE_TAX_FAILURE = '@fareTax/DELETE_FARE_TAX_FAILURE',

  DELETE_FARE_TAX_INTEGRATOR_REQUEST = '@fareTax/DELETE_FARE_TAX_INTEGRATOR_REQUEST',
  DELETE_FARE_TAX_INTEGRATOR_SUCCESS = '@fareTax/DELETE_FARE_TAX_INTEGRATOR_SUCCESS',
  DELETE_FARE_TAX_INTEGRATOR_FAILURE = '@fareTax/DELETE_FARE_TAX_INTEGRATOR_FAILURE',
}

/*
 * Data types
 */

interface FareTaxValuesInterface {
  id: string;
  from: number;
  to: number | null;
  value: number;
  valueType: string;
  createdAt: string;
  updatedAt: string;
  fareTaxId: string;
}

interface FareTaxLineSectionLineSectionInterface {
  stopId: string;
  lineSectionIds: string[];
}

interface FareTaxUpdateRequest {
  id: string;
  data: {
    fareTaxId: string;
    name: string;
    fareTaxIntegratorId: null | string;
    type: string;
    validFrom: string;
    transportOperatorId: string;
    fareTaxValues: FareTaxValuesInterface[];
    stopLineSections: FareTaxLineSectionLineSectionInterface[];
  };
  validFrom: string;
  updated: boolean;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  fareTaxId: string;
}

export interface FareTaxInterface {
  id: string;
  name: string;
  type: string;
  status: number;
  validFrom: Date | null;
  keepUntil: Date | null;
  createdAt: Date;
  updatedAt: Date;
  fareTaxIntegratorId: string | null;
  transportOperatorId: string;
  FareTaxValues: FareTaxValuesInterface[];
  FareTaxUpdateRequests: FareTaxUpdateRequest[];
  Stops?: StopBaseInterface[];
  LineSections?: LineSectionBaseInterface[];
}

export interface FareTaxIntegratorInterface {
  id: string;
  type: string;
  status: number;
  createdAt: Date;
  updatedAt: Date;
  transportOperatorId: string;
  FareTaxIntegratorFields: FareTaxIntegratorField[];
}

export interface FareTaxIntegratorField {
  id: string;
  key: string;
  value: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  fareTaxIntegratorId: string;
}

/*
 * State type
 */
export interface FareTaxState {
  readonly fareTaxList: FareTaxInterface[];
  readonly fareTaxIntegratorList: FareTaxIntegratorInterface[];
  readonly fareTaxData: FareTaxInterface | null;
  readonly fareTaxIntegratorData: FareTaxIntegratorInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
